import type { IForenkletStyringNivaa1Report } from "./902InitialData.js";

export const get902Stats = (report: IForenkletStyringNivaa1Report | null | undefined) => {
  const counts = { RED: 0, YELLOW: 0, LIGHT_GREEN: 0, DARK_GREEN: 0, BLUE: 0, GRAY: 0, unanswered: 0 };
  for (const row of report?.rows ?? []) {
    if (row.kind !== "QUESTION") continue;
    if (row.assessment == null) counts.unanswered++;
    else counts[row.assessment]++;
  }
  const total = Object.values(counts).reduce((sum, count) => sum + count, 0);
  const resolved = counts.DARK_GREEN + counts.GRAY;
  const processed = total - counts.unanswered;
  const percent = (count: number) => (total === 0 ? 0 : (count / total) * 100);
  return {
    total,
    counts,
    resolved,
    processed,
    completionPercent: Math.round(percent(resolved)),
    processedPercent: Math.round(percent(processed)),
    percentages: {
      RED: percent(counts.RED),
      YELLOW: percent(counts.YELLOW),
      LIGHT_GREEN: percent(counts.LIGHT_GREEN),
      DARK_GREEN: percent(counts.DARK_GREEN),
      BLUE: percent(counts.BLUE),
      GRAY: percent(counts.GRAY),
      unanswered: percent(counts.unanswered),
    },
  };
};